import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { CatalogMoldSize } from "../models/CatalogMoldSize";

export const getCatalogMoldSizes = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[CAS].[GetMoldSizes]", []);
};
export const upsertCatalogMoldSize = async (MoldSize: CatalogMoldSize) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "MoldSizeId", value: MoldSize.MoldSizeId },
    { name: "MoldSizeName", value: MoldSize.MoldSizeName },
    { name: "Height", value: MoldSize.Height },
    { name: "Width", value: MoldSize.Width },
    { name: "Code", value: MoldSize.Code },
    { name: "MinSpeedLimit", value: MoldSize.MinSpeedLimit },
    { name: "LbsPerInch", value: MoldSize.LbsPerInch },
    { name: "Enabled", value: MoldSize.Enabled },
  ];

  return await apiService.callV2("[CAS].[UpsertMoldSize]", parameters);
};

export const deleteCatalogMoldSize = async (MoldSizeId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "MoldSizeId", value: MoldSizeId }];

  return await apiService.callV2("[CAS].[DeleteMoldSize]", parameters);
};
